import { render, staticRenderFns } from "./genedetail.vue?vue&type=template&id=ea91838a&scoped=true&"
import script from "./genedetail.vue?vue&type=script&lang=js&"
export * from "./genedetail.vue?vue&type=script&lang=js&"
import style0 from "./genedetail.vue?vue&type=style&index=0&id=ea91838a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea91838a",
  null
  
)

export default component.exports